import React from "react";
import { Navigate } from "react-router-dom";
const professorGuard = (Element) => {
  return (props) => {
    localStorage.getItem("xAuthToken");
    let user = localStorage.getItem("user");
    user = JSON.parse(user);

    if (user.role === "PROFESSOR" && user?.status === "denied")
      return <Navigate to="/access-denied" replace />;

    if (user.role === "PROFESSOR") {
      return <Element {...props} />;
    } else {
      return <Navigate to="/dashboard" {...props} />;
    }
  };
};

export default professorGuard;
